/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: ea99bacb (Fri Jun  5 23:34:18 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { ProgramType } from './'

/**
 * Represents an account against which licensing payments can be made.
 * @export
 * @interface LicensingBillingAccount
 */
export interface LicensingBillingAccount {
  /**
   *
   * @type string
   * @memberof LicensingBillingAccount
   */
  type: LicensingBillingAccountTypeEnum
  /**
   *
   * @type number
   * @memberof LicensingBillingAccount
   */
  programKey: number
  /**
   *
   * @type ProgramType
   * @memberof LicensingBillingAccount
   */
  programType?: ProgramType
  /**
   * The starting date for the program's first semester in date format: `yyyy-MM-dd`.
   * @type Date
   * @memberof LicensingBillingAccount
   */
  semesterOneStartDate?: Date
  /**
   * The name of the program's community.
   * @type string
   * @memberof LicensingBillingAccount
   */
  communityName?: string
  /**
   * The role of the program director
   * @type string
   * @memberof LicensingBillingAccount
   */
  programDirectorRole?: string
  /**
   * indicates when the requester is a tutor.
   * @type boolean
   * @memberof LicensingBillingAccount
   */
  isTutor?: boolean
  /**
   * The unique identifier of the actor, either a director or a tutor.
   * @type number
   * @memberof LicensingBillingAccount
   */
  actorKey?: number
}

/**
 * @export
 * @enum {string}
 */
export enum LicensingBillingAccountTypeEnum {
  Licensing = 'Licensing',
}

export function LicensingBillingAccountFromJSON(
  json: any
): LicensingBillingAccount {
  return LicensingBillingAccountFromJSONTyped(json, false)
}

export function LicensingBillingAccountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LicensingBillingAccount {
  if (json === undefined || json === null) {
    return json
  }
  return {
    type: json['type'],
    programKey: json['programKey'],
    programType: !exists(json, 'programType') ? undefined : json['programType'],
    semesterOneStartDate: !exists(json, 'semesterOneStartDate')
      ? undefined
      : new Date(json['semesterOneStartDate']),
    communityName: !exists(json, 'communityName')
      ? undefined
      : json['communityName'],
    programDirectorRole: !exists(json, 'programDirectorRole')
      ? undefined
      : json['programDirectorRole'],
    isTutor: !exists(json, 'isTutor') ? undefined : json['isTutor'],
    actorKey: !exists(json, 'actorKey') ? undefined : json['actorKey'],
  }
}

export function LicensingBillingAccountToJSON(
  value?: LicensingBillingAccount | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    type: value.type,
    programKey: value.programKey,
    programType: value.programType,
    semesterOneStartDate:
      value.semesterOneStartDate === undefined
        ? undefined
        : value.semesterOneStartDate.toISOString().substr(0, 10),
    communityName: value.communityName,
    programDirectorRole: value.programDirectorRole,
    isTutor: value.isTutor,
    actorKey: value.actorKey,
  }
}
